import React, { useEffect, useRef } from "react";
import { Star } from "lucide-react";
import { REVIEWS_DATA } from "../../constants";

export const ReviewsSection = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let animationId;
    let scrollPos = 0;
    const scroll = () => {
      scrollPos += 0.5;
      if (scrollPos >= scrollContainer.scrollWidth / 2) scrollPos = 0;
      scrollContainer.scrollLeft = scrollPos;
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    for (let i = 0; i < fullStars; i++) stars.push(<Star key={`full-${i}`} size={14} className="fill-[#FFD166] text-[#FFD166]" />);
    if (hasHalfStar) {
      stars.push(
        <div key="half" className="relative">
          <Star size={14} className="text-gray-200" />
          <div className="absolute inset-0 overflow-hidden w-1/2"><Star size={14} className="fill-[#FFD166] text-[#FFD166]" /></div>
        </div>
      );
    }
    for (let i = stars.length; i < 5; i++) stars.push(<Star key={`empty-${i}`} size={14} className="text-gray-200" />);
    return stars;
  };

  return (
    <section id="reviews" className="py-20 md:py-28 bg-gradient-to-b from-[#FFFAF5] to-white overflow-hidden" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Outfit'] text-3xl md:text-4xl font-bold text-[#1E1B4B] mb-4">Loved by Families</h2>
          <div className="section-divider mb-4"></div>
          <p className="text-[#475569]">500+ Happy Families Share Their DoozyGo® Experience</p>
        </div>
      </div>
      <div ref={scrollRef} className="flex gap-6 overflow-hidden whitespace-nowrap py-4" style={{ WebkitOverflowScrolling: 'touch' }}>
        {[...REVIEWS_DATA, ...REVIEWS_DATA].map((review, idx) => (
          <div key={`review-${idx}`} className="inline-block w-80 flex-shrink-0 bg-white rounded-2xl p-5 shadow-lg border border-gray-100" data-testid={`review-card-${idx}`}>
            <div className="flex gap-1 mb-3">{renderStars(review.rating)}</div>
            <p className="text-[#475569] text-sm mb-4 whitespace-normal line-clamp-3">"{review.text}"</p>
            <div className="flex items-center gap-3">
              <img src={`https://i.pravatar.cc/100?img=${review.avatar}`} alt={review.name} className="w-10 h-10 rounded-full object-cover" />
              <div><p className="font-semibold text-[#1E1B4B] text-sm">{review.name}</p><p className="text-xs text-[#475569]">{review.location}</p></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
